export default "__VITE_ASSET__R5skl5PP__"